import React from 'react';
import Logo from '../../assets/logo.gif'; // Replace with your actual logo path
import CenterImage from '../../assets/logo.png'; // Replace with your actual center image path
import './Presale.css';
import PresaleBox from '../presaleBox';
import { useEffect, useState } from 'react';
import { formatUnits } from 'ethers';

const PresaleSection = ({vContract, uContract, pvContract}) => {

  const [currentStage, setCurrentStage] = useState(0);
  const [currentStageCap, setCurrentCap] = useState(0);
  const [currentUsdPrice, setCurrentUsdPrice] = useState("0");
  const [currentBnbPrice, setCurrentBnbPrice] = useState("0");
  const [remainTokens, setRemTokens] = useState(0);
//  const [remainTime, setRemTime] = useState(0);
  const [active, setActive] = useState(false);
  const [sTime, setSTime] = useState(0);
  const [eTime, setETime] = useState(0);

  const getData = async() => {

    const isActive = await pvContract.isActive();

    if(isActive) {
      try {
      const currStage = await pvContract.currentStage();
      const currStageCap = await pvContract.getCurrentStageCap();
      const currStagePrice = await pvContract.getCurrentStagePrice();
      const remainingTokens = await pvContract.getRemainingTokensForCurrentStage();
      const startTime = await pvContract.getStageStartTime();
      const endTime = await pvContract.getStageEndTime();

      setCurrentStage(Number(currStage));
      setCurrentCap(formatUnits(currStageCap));
      setCurrentUsdPrice(formatUnits(currStagePrice[0]));
      setCurrentBnbPrice(formatUnits(currStagePrice[1]));
      setRemTokens(formatUnits(remainingTokens));
     // setRemTime(remainingTime);
      setSTime(Number(startTime));
      setETime(Number(endTime));
    } catch (error) {
        console.log(error);
    }
    }

    setActive(isActive);
  }

  useEffect(() => {
    if(pvContract) {
      getData();
    }
  }, [pvContract])

  return (
    <section className="presale-section" id="presale">
      {/* Left side: images */}
      <div className="presale-images">
        <div className="logo-container">
          <img
            src={Logo}
            alt="Circular Logo"
            className="logo-background"
          />
          <img
            src={CenterImage}
            alt="Center Overlay"
            className="logo-overlay"
          />
        </div>
      </div>

      {/* Right side: presale box */}
      <PresaleBox
        countdownTimestamp={eTime} // 24 hours from now
        totalAmount={currentStageCap}
        soldAmount={currentStageCap - remainTokens}
        usdPrice={currentUsdPrice}
        bnbPrice={currentBnbPrice}
        usdtContract={uContract}
        vendorContract={vContract}
        soldTokens={currentStageCap - remainTokens}
        availableTokens={remainTokens}
        />
    </section>
  );
};

export default PresaleSection;
